import {
  SignedDocumentDto,
  TextDocumentDto,
  ViewDocumentAsOwnerDto,
} from "../../autogen/bff-api";

export const isViewDocumentAsOwnerDto = (doc?: Record<string, unknown>): doc is ViewDocumentAsOwnerDto =>
  !!doc &&
  !!doc.id &&
  !!doc.name &&
  !!doc.mimeType &&
  !!doc.fileExtension &&
  !!doc.size &&
  !!doc.uploadedAt &&
  !!doc.uploadedBy &&
  !!doc.s3Key &&
  !!doc.fromUploadId;

export const isTextDocument = (doc?: Record<string, unknown>): doc is TextDocumentDto =>
  !!doc &&
  !!doc.id &&
  !!doc.createdAt &&
  !!doc.modifiedAt &&
  !!doc.owner &&
  (!!doc.name || doc.name === "") &&
  (!!doc.text || doc.text === "") &&
  !!doc.tags;

export const isSignedDocumentDto = (doc?: Record<string, unknown>): doc is SignedDocumentDto =>
  !!doc &&
  !!doc.id &&
  !!doc.uploadedAt &&
  !!doc.sentForSigningBy &&
  !!doc.status &&
  !!doc.signers &&
  !!doc.signicatDocumentId &&
  (doc.signingCompleted === true || doc.signingCompleted === false);

export const isUnsignedSignedDocument = (doc: Record<string, unknown>): boolean =>
  isSignedDocumentDto(doc) && !doc.signingCompleted;

export const isSignable = (file: { size: number; fileExtension: string }) =>
  file.fileExtension === ".pdf" && file.size < 25_000_000;

export const isPdf = (file: { fileExtension: string }) => file.fileExtension === ".pdf";

export const isPdfExtension = (extension: string) => extension.replace(".", "").toLowerCase() === "pdf";

export type AnnouncementAttachment = {
  kind: "announcementAttachment";
  id: string;
  eventId: string;
  name: string;
  publishedAt: string;
};

export const isAnnouncementAttachment = (doc?: Record<string, unknown>): doc is AnnouncementAttachment =>
  !!doc && doc.kind === "announcementAttachment";

export const getFileExtension = (fileName: string) => {
  const segments = fileName.split(".");
  return segments.length > 1 ? segments[segments.length - 1] : "";
};
